import React, { useEffect, useRef, useState } from "react";
import logo from "../../../assets/images/logo.png";
import { Image } from "primereact/image";
import AccountTypeModal, { AccountType } from "../Login_Page/AccountTypeModal";

import {
  MdLocationOn,
  MdShoppingCart,
  MdAccountCircle,
  MdMenu,
  MdClose,
  MdOutlineKeyboardArrowDown,
  MdOutlineAccountCircle,
  MdLogin,
} from "react-icons/md";
import styles from "./Header.module.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCity, setCityData } from "../../../redux/citySlice";
import { Button } from "primereact/button";
import useHeroAPI from "../../../api/useHeroAPI";
import { useDispatch } from "react-redux";
import { setSelectedCity } from "../../../redux/citySlice";
import { AutoComplete } from "primereact/autocomplete";
import useCartAPI from "../../../api/useCartAPI";
import { updateCartQuantity } from "../../../features/cart/cartSlice";
import { Dialog } from "primereact/dialog";
import { MdGpsFixed, MdSearch } from "react-icons/md";
import locationPin from "../../../assets/images/location_pin.png";
import { BiShoppingBag } from "react-icons/bi";
import {
  isLoggedInState,
  isLoggedOutState,
  logInUserFunc,
} from "../../../redux/userState";
import { RootState } from "../../../app/store";
import LoginModal from "../Login_Page/LoginModal";
import { RiLoginBoxLine } from "react-icons/ri";

interface HeaderProps {
  cartCount?: number;
}

export default function Header({}: HeaderProps) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isUserLoggedin = useSelector(isLoggedInState);
  const isUserLoggedOut = useSelector(isLoggedOutState);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const selectedCityState = useSelector(selectCity);
  const [authStep, setAuthStep] = useState<"none" | "accountType" | "login">(
    "none",
  );
  const [selectedAccountType, setSelectedAccountType] =
    useState<AccountType>("customer");
  const [cityOptions, setCityOptions] = useState(null) as any;
  const [selectingCityDialog, setSelectingCityDialog] = useState(false) as any;
  const [location, setLocation] = useState("Fetching location...");
  const [headerLoader, headerSetLoader] = useState(false);
  const [selectedServicePoint, setSelectedServicePoint] = useState(null) as any;
  const [filteredServicePoint, setFilteredServicePoint] = useState([]);
  const [userName, setUserName] = useState(null) as any;
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [userIsLoggin, setUserIsLoggin] = useState(false);
  const basePath = process.env.REACT_APP_BASE_PATH;
  const navRef = useRef() as any;
  const { predefinedFunc } = useHeroAPI();

  const { cartCount: cartCountApi } = useCartAPI();
  const showNavbar = () => {
    navRef?.current?.classList.toggle("responsive_nav");
  };
  useEffect(() => {
    const user: any = localStorage?.getItem("authTokens");
    const authTokens = JSON.parse(localStorage.getItem("authTokens") ?? "{}");

    if (authTokens?.user?.full_name) {
      const firstName = authTokens?.user?.full_name.split(" ")[0];
      setUserName(firstName);
    }
    // Check if the user token exists and is not "undefined"
    if (user && user !== "undefined") {
      const parsedUser = JSON.parse(user);
      // Additional checks can be added here to validate the token
      setUserIsLoggin(true);
    } else {
      setUserIsLoggin(false);
    }
  }, [isUserLoggedin, isUserLoggedOut]);
  useEffect(() => {
    const fetchCities = async () => {
      const payload = {
        entity_type: "CITY",
      };

      const response = await predefinedFunc(payload);

      if (response.status === 200) {
        setCityOptions(response.data.data);
      }
    };

    fetchCities();
  }, []);
  useEffect(() => {
    const city = localStorage.getItem("selectedCity");

    if (city) {
      dispatch(setSelectedCity(city));
    }
  }, [dispatch]);
  const fetchCurrentLocation = async (manually = false) => {
    if (!navigator.geolocation) {
      setLocation("Geolocation is not supported by your browser.");
      return;
    }

    headerSetLoader(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          // Check user's browser language
          const preferredLanguage = navigator.language || "en";

          // ===============================
          // 1. ALWAYS GET ENGLISH LOCATION
          // This will be used for DB/search/localStorage
          // ===============================
          const englishResponse = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&language=en&key=AIzaSyDj9D7Sm1MLG1y4CimROoQu1SSUl4OnHyI`,
          );

          const englishData = await englishResponse.json();

          // ===============================
          // 2. GET LOCATION IN USER LANGUAGE
          // This will be used only for UI
          // ===============================
          const displayResponse = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&language=${preferredLanguage}&key=AIzaSyDj9D7Sm1MLG1y4CimROoQu1SSUl4OnHyI`,
          );

          const displayData = await displayResponse.json();

          if (englishData.results?.[0] && displayData.results?.[0]) {
            // =====================================
            // GET ENGLISH CITY
            // =====================================
            const englishAddressComponents =
              englishData.results[0].address_components;

            const englishLocalityComponent = englishAddressComponents.find(
              (component: { types: string[] }) =>
                component.types.includes("locality"),
            );

            const englishPostalCodeComponent = englishAddressComponents.find(
              (component: { types: string[] }) =>
                component.types.includes("postal_code"),
            );

            const englishCity = englishLocalityComponent?.short_name || "";

            const postalCode = englishPostalCodeComponent?.short_name || "";

            // =====================================
            // GET CITY IN USER'S PREFERRED LANGUAGE
            // =====================================
            const displayAddressComponents =
              displayData.results[0].address_components;

            const displayLocalityComponent = displayAddressComponents.find(
              (component: { types: string[] }) =>
                component.types.includes("locality"),
            );

            const displayCity =
              displayLocalityComponent?.short_name || englishCity;

            // =====================================
            // CREATE UI LOCATION
            // =====================================
            const displayLocation = postalCode
              ? `${displayCity} - ${postalCode}`
              : displayCity;

            // UI STATE
            setLocation(displayLocation);

            // IMPORTANT:
            // Always use English for filtering/searching
            setSelectedServicePoint(englishCity);

            // =====================================
            // LOCAL STORAGE
            // =====================================

            // English → search/filter/database purpose
            localStorage.setItem("locationM", englishCity);

            // Hindi/English → UI display purpose
            localStorage.setItem("displayLocationM", displayLocation);

            localStorage.setItem("latitude", latitude.toString());

            localStorage.setItem("longitude", longitude.toString());
          } else {
            console.warn("No results found");

            setLocation("Select Location - Unknown Pincode");

            localStorage.removeItem("locationM");
            localStorage.removeItem("displayLocationM");
            localStorage.removeItem("latitude");
            localStorage.removeItem("longitude");
          }
        } catch (error) {
          console.error("Error fetching address:", error);

          setLocation("Error retrieving location.");

          localStorage.removeItem("latitude");
          localStorage.removeItem("longitude");
        } finally {
          headerSetLoader(false);
        }
      },

      (error) => {
        console.error("Error getting location:", error);

        setLocation("Unable to retrieve location.");

        if (manually) {
          alert("Please enable location access.");
        }

        headerSetLoader(false);
      },
    );
  };
  // const fetchCurrentLocation = async (manually = false) => {
  //   if (!navigator.geolocation) {
  //     setLocation("Geolocation is not supported by your browser.");
  //     return;
  //   }

  //   headerSetLoader(true);

  //   navigator.geolocation.getCurrentPosition(
  //     async (position) => {
  //       const { latitude, longitude } = position.coords;
  //       try {
  //         const response = await fetch(
  //           `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDj9D7Sm1MLG1y4CimROoQu1SSUl4OnHyI`,
  //         );
  //         const data = await response.json();
  //         if (data.results && data.results[0]) {
  //           const addressComponents = data.results[0].address_components;

  //           const localityComponent = addressComponents.find(
  //             (component: { types: string | string[] }) =>
  //               component.types.includes("locality"),
  //           );
  //           const localityShortName = localityComponent?.short_name || "";

  //           const postalCodeComponent = addressComponents.find(
  //             (component: { types: string | string[] }) =>
  //               component.types.includes("postal_code"),
  //           );
  //           const postalCode = postalCodeComponent?.short_name || "";

  //           const location = postalCode
  //             ? `${localityShortName} - ${postalCode}`
  //             : localityShortName;

  //           setLocation(location);
  //           setSelectedServicePoint(location.split("-")[0].trim());
  //           localStorage.setItem("locationM", location);
  //           localStorage.setItem("latitude", latitude.toString());
  //           localStorage.setItem("longitude", longitude.toString());
  //         } else {
  //           console.warn("No results found");
  //           setLocation("Select Location - Unknown Pincode");
  //           localStorage.setItem("locationM", "");
  //           localStorage.removeItem("latitude");
  //           localStorage.removeItem("longitude");
  //         }
  //       } catch (error) {
  //         console.error("Error fetching address:", error);
  //         setLocation("Error retrieving location.");
  //         localStorage.removeItem("latitude");
  //         localStorage.removeItem("longitude");
  //       } finally {
  //         headerSetLoader(false); // turns off only after geocode finishes
  //       }
  //     },
  //     (error) => {
  //       console.error("Error getting location:", error);
  //       setLocation("Unable to retrieve location.");
  //       if (manually) {
  //         alert("Please enable location access.");
  //       }
  //       headerSetLoader(false); // turns off on permission denial too
  //     },
  //   );
  // };
  // const fetchCurrentLocation = async (manually = false) => {
  //   headerSetLoader(true);
  //   try {
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         async (position) => {
  //           const { latitude, longitude } = position.coords;
  //           try {
  //             const response = await fetch(
  //               `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDj9D7Sm1MLG1y4CimROoQu1SSUl4OnHyI`,
  //             );
  //             const data = await response.json();
  //             if (data.results && data.results[0]) {
  //               const addressComponents = data.results[0].address_components;

  //               // Find the locality short name
  //               const localityComponent = addressComponents.find(
  //                 (component: { types: string | string[] }) =>
  //                   component.types.includes("locality"),
  //               );
  //               const localityShortName = localityComponent?.short_name || "";

  //               // Find the postal code (pincode)
  //               const postalCodeComponent = addressComponents.find(
  //                 (component: { types: string | string[] }) =>
  //                   component.types.includes("postal_code"),
  //               );
  //               const postalCode = postalCodeComponent?.short_name || "";

  //               // Combine locality and pincode
  //               const location = postalCode
  //                 ? `${localityShortName} - ${postalCode}`
  //                 : localityShortName;
  //               console.log(location, "locationM::::::::::::::::::::;;");
  //               setLocation(location);
  //               // setSelectedServicePoint(location[0]?.trim());
  //               setSelectedServicePoint(location.split("-")[0].trim());
  //               // Assuming setLocation is the state setter
  //               localStorage.setItem("locationM", location);
  //               localStorage.setItem("latitude", latitude.toString());
  //               localStorage.setItem("longitude", longitude.toString());
  //             } else {
  //               console.warn("No results found");
  //               setLocation("Select Location - Unknown Pincode");
  //               localStorage.setItem("locationM", "");
  //               localStorage.removeItem("latitude");
  //               localStorage.removeItem("longitude");
  //             }
  //           } catch (error) {
  //             console.error("Error fetching address:", error);
  //             setLocation("Error retrieving location.");
  //             localStorage.removeItem("latitude");
  //             localStorage.removeItem("longitude");
  //           }
  //         },
  //         (error) => {
  //           console.error("Error getting location:", error);
  //           setLocation("Unable to retrieve location.");
  //           if (manually) {
  //             alert("Please enable location access.");
  //           }
  //         },
  //       );
  //     } else {
  //       setLocation("Geolocation is not supported by your browser.");
  //     }
  //   } finally {
  //     headerSetLoader(false);
  //   }
  // };
  useEffect(() => {
    fetchCurrentLocation();
  }, []);
  const search = (event: any) => {
    let filtered;

    if (!event.query.trim().length) {
      filtered = [...cityOptions];
    } else {
      filtered = cityOptions.filter((city: any) =>
        city.name.toLowerCase().startsWith(event.query.toLowerCase()),
      );
    }

    setFilteredServicePoint(filtered);
  };
  const handleLocationSelection = async (e: any) => {
    // console.log("handleLocationSelection:::::::::::::::",e.value);
    setSelectingCityDialog(false);
    localStorage.setItem("selectedCity", e.value.predefined_id);
    dispatch(setSelectedCity(e.value.predefined_id));
    dispatch(setCityData(e.value));
  };
  const handleLocationSelect = (e: any) => {
    setSelectedServicePoint(e.value);
    // console.log("handleLocationSelect:::::::::::::::",e.value);

    // Add this - save city when selected from dropdown
    if (typeof e.value === "object" && e.value?.predefined_id) {
      localStorage.setItem("selectedCity", e.value.predefined_id);
      dispatch(setSelectedCity(e.value.predefined_id));
      setSelectingCityDialog(false);
    }
  };
  const itemTemplate = (item: any) => {
    return (
      <div className="auto-complete-text-wrapper">
        <div className="auto-complete-container">
          <Image
            alt={item.name}
            src={locationPin}
            className={`auto-complete-pin-img`}
            // style={{ width: "26px" }}
          />
          <div>
            {item.name} - {item.field3}
          </div>
        </div>
        <hr />
      </div>
    );
  };
  const redirectToCart = (e: any) => {
    e.preventDefault();
    navigate(`${basePath}cart`);
  };

  const fetchCartProducts = async () => {
    const payload = {};
    const response: any = await cartCountApi(payload);

    if (response?.status === 200) {
      const newCartQuantity = response?.data?.count ?? 0;
      dispatch(updateCartQuantity(newCartQuantity));
    } else {
      dispatch(updateCartQuantity(0));
    }
  };

  // const redirectToProfile = () => {
  //   if (isUserLoggedin || userIsLoggin) {
  //     navigate(`${basePath}profile`);
  //   } else {
  //     navigate(`${basePath}login`);

  //   }
  // };
  // const redirectToProfile = () => {
  //   console.log("Profile clicked");
  //   console.log(`${basePath}profile`);
  //   navigate(`${basePath}profile`);
  // };
  const redirectToProfile = () => {
    if (isUserLoggedin || userIsLoggin) {
      navigate(`${basePath}profile`);
    } else {
      setAuthStep("accountType");
    }
  };
  const openLocationDialog = () => {
    setSelectingCityDialog(true);
  };
  const cartQuantity = useSelector(
    (state: RootState) => state.cart.cartQuantity,
  );

  useEffect(() => {
    fetchCartProducts();
  }, [isUserLoggedin, isUserLoggedOut]);

  useEffect(() => {
    const user: any = localStorage?.getItem("authTokens");
    const authTokens = JSON.parse(localStorage.getItem("authTokens") ?? "{}");

    if (authTokens?.user?.full_name) {
      const firstName = authTokens?.user?.full_name.split(" ")[0];
      setUserName(firstName);
    }
    // Check if the user token exists and is not "undefined"
    if (user && user !== "undefined") {
      const parsedUser = JSON.parse(user);
      // Additional checks can be added here to validate the token
      setUserIsLoggin(!!parsedUser);
    } else {
      setUserIsLoggin(false);
    }
  }, [isUserLoggedin, isUserLoggedOut]);
  // const displayLocationLabel =
  //   selectedCityState &&
  //   cityOptions?.find((city: any) => city.predefined_id === selectedCityState)
  //     ?.name
  //     ? cityOptions.find(
  //         (city: any) => city.predefined_id === selectedCityState,
  //       ).name
  //     : localStorage.getItem("locationM") &&
  //         localStorage.getItem("locationM") !== ""
  //       ? localStorage.getItem("locationM")
  //       : location && location !== "Fetching location..."
  //         ? location
  //         : "Location";
  const displayLocationLabel =
    selectedCityState &&
    cityOptions?.find((city: any) => city.predefined_id === selectedCityState)
      ?.name
      ? cityOptions.find(
          (city: any) => city.predefined_id === selectedCityState,
        ).name
      : localStorage.getItem("displayLocationM") &&
          localStorage.getItem("displayLocationM") !== ""
        ? localStorage.getItem("displayLocationM")
        : location && location !== "Fetching location..."
          ? location
          : "Location";
  // console.log("hello header");
  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.container}>
          {/* Logo and Desktop Nav */}
          <div className={styles.leftSection}>
            <div>
              <Link to={`${basePath}`}>
                <Image src={logo} alt="Image" width="132" height="32px" />
              </Link>
              {/* {JSON.stringify(logo)} */}
            </div>
          </div>

          {/* Right Nav Icons */}
          <div className={styles.rightSection}>
            <div className={styles.desktopNav}>
              <nav ref={navRef}>
                <NavLink
                  to={`${basePath}`}
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.activeLink : ""}`
                  }
                  onClick={() => {
                    showNavbar();
                  }}
                >
                  Tyres
                </NavLink>
                <NavLink
                  onClick={() => {
                    showNavbar();
                    navigate(`${basePath}batteries`, {
                      state: {
                        code: "BATTERY",
                      },
                    });
                  }}
                  to={`${basePath}batteries`}
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.activeLink : ""}`
                  }
                >
                  Batteries
                </NavLink>
                <NavLink
                  to={`${basePath}puncture`}
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.activeLink : ""}`
                  }
                  onClick={showNavbar}
                >
                  Accessories
                </NavLink>

                <NavLink
                  to={`${basePath}servicesandrepair`}
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.activeLink : ""}`
                  }
                  onClick={() => {
                    showNavbar();
                  }}
                >
                  Services and Repair
                </NavLink>
                <NavLink
                  to={`${basePath}findservicepoints`}
                  className={({ isActive }) =>
                    `${styles.navLink} ${isActive ? styles.activeLink : ""}`
                  }
                  onClick={() => {
                    showNavbar();
                  }}
                >
                  Find Service Points
                </NavLink>

                <button
                  className={`${styles.iconBtn} ${styles.locationBtn}`}
                  aria-label="Location"
                  onClick={openLocationDialog}
                >
                  <MdLocationOn size={22} />
                  <span className={styles.iconLabel}>
                    {displayLocationLabel}
                  </span>
                </button>
              </nav>
            </div>

            {/* <<<<<<<<<<cart and profile buttons>>>>>>>>>>>>> */}

            {!isUserLoggedin && !userIsLoggin && (
              <button
                className={`${styles.iconBtn} ${styles.locationBtn}`}
                onClick={redirectToProfile}
              >
                <MdLogin />
                <span>Login</span>
              </button>
            )}
            {isUserLoggedin && userIsLoggin && (
              <>
                <div className={styles.cartBtnContainer}>
                  <button
                    className={styles.iconBtn}
                    aria-label="Shopping Cart"
                    onClick={(e) => redirectToCart(e)}
                  >
                    <MdShoppingCart size={22} />
                  </button>

                  {cartQuantity > 0 && (
                    <span className={styles.cartBadge}>{cartQuantity}</span>
                  )}
                </div>

                <button
                  className={styles.iconBtn}
                  aria-label="User Account"
                  onClick={redirectToProfile}
                >
                  <MdAccountCircle size={22} />
                </button>
              </>
            )}
            {authStep === "accountType" && (
              <AccountTypeModal
                visible={authStep === "accountType"}
                onHide={() => setAuthStep("none")}
                onSelect={(type) => {
                  setSelectedAccountType(type);
                  setAuthStep("login");
                  setTimeout(() => {
                    setAuthStep("login");
                  }, 0);
                }}
              />
            )}

            {/* <LoginModal
              visible={authStep === "login"}
              onHide={() => setAuthStep("none")}
              accountType={selectedAccountType}
              onLoginSuccess={() => {
                setUserIsLoggin(true);
                setAuthStep("none");
                navigate(`${basePath}profile`, {
                  state: { accountType: selectedAccountType },
                });
              }}
            /> */}
            <LoginModal
              visible={authStep === "login"}
              onHide={() => setAuthStep("none")}
              accountType={selectedAccountType}
              onLoginSuccess={() => {
                setAuthStep("none");
                setUserIsLoggin(true);
                dispatch(logInUserFunc());
                navigate(`${basePath}profile`);
              }}
            />
            <button
              className={styles.hamburgerBtn}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              {isMobileMenuOpen ? <MdClose size={24} /> : <MdMenu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Drawer */}
        {isMobileMenuOpen && (
          <div className={styles.mobileMenu}>
            <NavLink
              to={`${basePath}`}
              // className={styles.mobileNavLink}
              // className={`${styles.mobileNavLink} ${styles.activeLink}`}
              className={({ isActive }) =>
                `${styles.mobileNavLink} ${isActive ? styles.activeLink : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Tyres
            </NavLink>
            <NavLink
              to={`${basePath}batteries`}
              // className={styles.mobileNavLink}
              className={({ isActive }) =>
                `${styles.mobileNavLink} ${isActive ? styles.activeLink : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Batteries
            </NavLink>
            <NavLink
              to={`${basePath}puncture`}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.activeLink : ""}`
              }
              // onClick={showNavbar}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Accessories
            </NavLink>

            <NavLink
              to={`${basePath}servicesandrepair`}
              // className={styles.mobileNavLink}
              className={({ isActive }) =>
                `${styles.mobileNavLink} ${isActive ? styles.activeLink : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Services & Repair
            </NavLink>
            <NavLink
              to={`${basePath}findservicepoints`}
              // className={styles.mobileNavLink}
              className={({ isActive }) =>
                `${styles.mobileNavLink} ${isActive ? styles.activeLink : ""}`
              }
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Find Service Points
            </NavLink>
            <button
              className={`${styles.mobileNavLink} ${styles.mobileLocationBtn}`}
              onClick={() => {
                openLocationDialog();
                setIsMobileMenuOpen(false);
              }}
            >
              <MdLocationOn size={20} />
              {displayLocationLabel}
            </button>
          </div>
        )}
      </nav>
      <Dialog
        visible={selectingCityDialog}
        modal
        style={{ width: "30%" }}
        onHide={() => setSelectingCityDialog(false)}
        header={"Please Select a City"}
        className=""
      >
        <span className="w-full">
          <AutoComplete
            field="name"
            value={selectedServicePoint}
            suggestions={filteredServicePoint}
            completeMethod={search}
            onChange={(e) => handleLocationSelect(e)}
            itemTemplate={itemTemplate}
            className="service-point-auto-complete"
            placeholder="Enter a location"
            onSelect={(e) => handleLocationSelection(e)}
          />
          <div className="auto-complete-icons-wrapper p-input-icon-right">
            <MdSearch className="auto-complete-search-location cursor-pointer" />
            {headerLoader ? (
              <span
                className={styles["gps-spinner"]}
                aria-label="Locating..."
              />
            ) : (
              <MdGpsFixed
                className="auto-complete-choose-location cursor-pointer"
                onClick={() => fetchCurrentLocation(true)}
              />
            )}
          </div>
          {/* <div className="auto-complete-icons-wrapper p-input-icon-right">
            <MdSearch className="auto-complete-search-location cursor-pointer" />
            {headerLoader ? (
              <span className="loader">Loading...</span>
            ) : (
              <MdGpsFixed
                className="auto-complete-choose-location cursor-pointer"
                onClick={() => fetchCurrentLocation(true)}
              />
            )}
          </div> */}
        </span>
      </Dialog>
    </>
  );
}
